var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone",
    transform: "translate(-12146 18042)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5304",
    "data-name": "Rectangle 5304",
    width: 24,
    height: 24,
    transform: "translate(12146 -18042)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Phone-2",
    "data-name": "Phone",
    d: "M137.847,14.072c-.783-1.4-3.532-2.71-5.1-2.738s-1.518,2.072-1.516,2.077a10.062,10.062,0,0,1-4.018-2.62,10.044,10.044,0,0,1-2.619-4.017c.005,0,2.1.052,2.077-1.517s-1.339-4.317-2.74-5.1-4.144,1.54-3.918,4.377a15.465,15.465,0,0,0,4.556,8.9,15.467,15.467,0,0,0,8.9,4.557c2.836.226,5.159-2.518,4.377-3.919",
    transform: "translate(12029 -18039.004)",
    fill: "#a1a1b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconGrey);
export default __webpack_public_path__ + "static/media/phoneIconGrey.7c584090362350441bc4de19810e135b.svg";
export { ForwardRef as ReactComponent };